import {
  inputPrompts,
  requestErrors,
  approvalsGroupText,
} from './approvals_group_text';

export const initialGroupState = {
  initialGroupName: '',
  nameInput: '',
  nameMaxLength: 0,
  nameIsValid: true,
  nameErrMsg: requestErrors.uniqueName,
  descriptionInput: '',
  descriptionMaxLength: 0,
  admins: [],
  adminsCount: 0,
  adminsSelectionCount: 0,
  adminsIsValid: true,
  adminsErrMsg: inputPrompts.addGroupAdmin,
  approvers: [],
  approversCount: 0,
  approversSelectionCount: 0,
  approversIsValid: true,
  users: [],
  usersCount: 0,
  usersSelectionCount: 0,
  usersIsValid: true,
  userModal: {
    showModal: false,
    title: '',
    cta: '',
    users: [],
    userCount: 0,
    modalSelectionCount: 0,
    currentSelectionCount: 0,
    selectAllUsers: false,
    orderByName: false,
    orderByLimit: false,
    actionType: '',
  },
  messageModal: {
    showModal: false,
    userType: '',
    userId: '',
    title: '',
    description:
      'The account administrator will receive all approval requests for users not assigned to a group.',
    cta: 'Remove',
  },
  inititalLoadRequest: true,
  submitGroupRequest: false,
  submitUserRequest: false,
  usersRequestParams: false,
  unloadListenerStatus: false,
};

export const approvalRoles = {
  ADMIN: 'administrator',
  APPROVER: 'approver',
  USER: 'standard',
};

export const requestParams = {
  ADMINS_ROLE: `?role=${approvalRoles.ADMIN}`,
  APPROVERS_ROLE: `?role=${approvalRoles.APPROVER}`,
  USERS_ROLE: '', // No params get both users and approver roles
};

export const groupActions = {
  INITITAL_GROUP_NAME: 'INITIAL_GROUP_NAME',
  NAME_INPUT: 'NAME_INPUT',
  NAME_ISVALID: 'NAME_ISVALID',
  NAME_INVALID: 'NAME_INVALID',
  DESCRIPTION_INPUT: 'DESCRIPTION_INPUT',
  ADMINS_ISVALID: 'ADMINS_ISVALID',
  ADMINS_INVALID: 'ADMINS_INVALID',
  UPDATE_ALL_ADMINS: 'UPDATE_ALL_ADMINS',
  UPDATE_ALL_APPROVERS: 'UPDATE_ALL_APPROVERS',
  UPDATE_ALL_USERS: 'UPDATE_ALL_USERS',
  CREATE_USER_MODAL: 'CREATE_USER_MODAL',
  UPDATE_USER_MODAL: 'UPDATE_USER_MODAL',
  SORT_BY_NAME_MODAL: 'SORT_BY_NAME_MODAL',
  SORT_BY_LIMIT_MODAL: 'SORT_BY_LIMIT_MODAL',
  SELECT_ALL_USER_MODAL: 'SELECT_ALL_USER_MODAL',
  CLEAR_ALL_USER_MODAL: 'CLEAR_ALL_USER_MODAL',
  SELECT_ALL_STATUS_MODAL: 'SELECT_ALL_STATUS_MODAL',
  RESET_USER_MODAL: 'RESET_USER_MODAL',
  OPEN_MESSAGE_MODAL: 'OPEN_MESSAGE_MODAL',
  REMOVE_MESSAGE_MODAL: 'REMOVE_MESSAGE_MODAL',
  UPDATE_GROUP_REQUEST: 'UPDATE_GROUP_REQUEST',
  ADD_USERS_REQUEST: 'ADD_USERS_REQUEST',
  UPDATE_USERS_REQUEST: 'UPDATE_USERS_REQUEST',
  ERROR_USERS_REQUEST: 'ERROR_USERS_REQUEST',
  INITIAL_LOAD_REQUEST: 'INITIAL_LOAD_REQUEST',
  SET_UNLOAD_STATUS: 'SET_UNLOAD_STATUS',
  RESET: 'RESET',
};

const filterSelectedUsers = usersList =>
  usersList.filter(user => user.selected);

const selectAllUsers = (usersList, filteredList, status) => {
  for (let i = 0; i < filteredList.length; i++) {
    for (let k = 0; k < usersList.length; k++) {
      if (filteredList[i].customer_id === usersList[k].customer_id) {
        usersList[k].selected = status;
      }
    }
  }
};

const deselectAllUsers = usersList => {
  usersList.forEach(user => {
    user.selected = false;
  });
};

const findUserIndex = (users, customerId) =>
  users.map(user => user.customer_id).indexOf(customerId);

const removeSelectedUser = (users, customerId) => {
  const userIndex = findUserIndex(users, customerId);
  users[userIndex].selected = !users[userIndex].selected;
};

const addSelectedUsers = (selectedUsers, users) => {
  if (selectedUsers.length === 0) return users;

  const selectedUsersIds = selectedUsers.reduce((acc, user) => {
    if (user.selected) {
      acc.push(user.customer_id);
    }
    return acc;
  }, []);

  users.forEach(user => {
    if (selectedUsersIds.includes(user.customer_id)) {
      user.selected = true;
    }
  });
  return users;
};

const selectionCount = users => {
  return users.reduce((acc, user) => {
    if (user.selected) {
      acc++;
    }
    return acc;
  }, 0);
};

export const approvalsGroupReducer = (state, action) => {
  const updatedState = { ...state };

  switch (action.type) {
    case groupActions.INITITAL_GROUP_NAME:
      updatedState.initialGroupName = action.payload;
      break;
    case groupActions.NAME_INPUT:
      updatedState.nameInput = action.payload;
      break;
    case groupActions.NAME_ISVALID:
      updatedState.nameIsValid = true;
      updatedState.nameErrMsg = action.payload;
      break;
    case groupActions.NAME_INVALID:
      updatedState.nameIsValid = false;
      updatedState.nameErrMsg = action.payload;
      break;
    case groupActions.DESCRIPTION_INPUT:
      updatedState.descriptionInput = action.payload;
      break;
    case groupActions.ADMINS_ISVALID:
      updatedState.adminsIsValid = true;
      updatedState.adminsErrMsg = action.payload;
      break;
    case groupActions.ADMINS_INVALID:
      updatedState.adminsIsValid = false;
      updatedState.adminsErrMsg = action.payload;
      break;
    case groupActions.UPDATE_ALL_ADMINS:
      updatedState.admins = action.payload;
      updatedState.adminsSelectionCount = selectionCount(action.payload);
      updatedState.adminsIsValid = action.payload.find(admin => admin.selected);
      break;
    case groupActions.UPDATE_ALL_APPROVERS:
      updatedState.approvers = action.payload;
      updatedState.approversSelectionCount = selectionCount(action.payload);
      break;
    case groupActions.UPDATE_ALL_USERS:
      updatedState.users = action.payload;
      updatedState.usersSelectionCount = selectionCount(action.payload);
      break;
    case groupActions.CREATE_USER_MODAL:
      updatedState.userModal = action.payload;
      break;
    case groupActions.SORT_BY_NAME_MODAL:
      updatedState.userModal.orderByName = !updatedState.userModal.orderByName;
      updatedState.userModal.orderByLimit = false;
      updatedState.userModal.users.sort((a, b) => {
        const currentName = `${a.forename} ${a.surname}`;
        const nextName = `${b.forename} ${b.surname}`;
        if (currentName < nextName) {
          return updatedState.userModal.orderByName ? -1 : 1;
        }
        if (currentName > nextName) {
          return updatedState.userModal.orderByName ? 1 : -1;
        }
        return 0;
      });
      break;
    case groupActions.SORT_BY_LIMIT_MODAL: {
      updatedState.userModal.orderByLimit =
        !updatedState.userModal.orderByLimit;

      updatedState.userModal.orderByName = false;

      let sortValue = '';
      if (updatedState.userModal.cta === approvalsGroupText.approvers.cta) {
        sortValue = 'max_approval_limit';
      }
      if (updatedState.userModal.cta === approvalsGroupText.users.cta) {
        sortValue = 'credit_limit';
      }

      if (updatedState.userModal.orderByLimit) {
        updatedState.userModal.users.sort(
          (a, b) => a[sortValue] - b[sortValue],
        );
      } else {
        updatedState.userModal.users.sort(
          (a, b) => b[sortValue] - a[sortValue],
        );
      }

      break;
    }
    case groupActions.UPDATE_USER_MODAL: {
      removeSelectedUser(updatedState.userModal.users, action.payload);

      updatedState.userModal.modalSelectionCount = filterSelectedUsers(
        updatedState.userModal.users,
      ).length;
      const { userCount, modalSelectionCount } = updatedState.userModal;
      updatedState.userModal.selectAllUsers = userCount === modalSelectionCount;
      break;
    }
    case groupActions.SELECT_ALL_USER_MODAL: {
      selectAllUsers(
        updatedState.userModal.users,
        action.payload,
        !updatedState.userModal.selectAllUsers,
      );
      updatedState.userModal.modalSelectionCount = filterSelectedUsers(
        updatedState.userModal.users,
      ).length;
      updatedState.userModal.selectAllUsers =
        !updatedState.userModal.selectAllUsers;
      break;
    }
    case groupActions.CLEAR_ALL_USER_MODAL:
      deselectAllUsers(updatedState.userModal.users);
      updatedState.userModal.modalSelectionCount = 0;
      updatedState.userModal.selectAllUsers = false;
      break;
    case groupActions.SELECT_ALL_STATUS_MODAL: {
      const selectedUsers = action.payload.filter(user => user.selected).length;
      updatedState.userModal.selectAllUsers =
        action.payload.length === selectedUsers;
      break;
    }
    case groupActions.RESET_USER_MODAL:
      updatedState.userModal = initialGroupState.userModal;
      break;
    case groupActions.OPEN_MESSAGE_MODAL: {
      updatedState.messageModal.showModal = true;
      updatedState.messageModal.userType = action.payload.title;
      const { forename, surname } = action.payload.user;
      updatedState.messageModal.userId = action.payload.user.customer_id;
      updatedState.messageModal.title = `Are you sure you would like to remove ${forename} ${surname} from this group?`;
      break;
    }
    case groupActions.REMOVE_MESSAGE_MODAL:
      if (
        updatedState.messageModal.userType === approvalsGroupText.admins.title
      ) {
        removeSelectedUser(
          updatedState.admins,
          updatedState.messageModal.userId,
        );
        updatedState.adminsSelectionCount--;
      }
      if (
        updatedState.messageModal.userType ===
        approvalsGroupText.approvers.title
      ) {
        removeSelectedUser(
          updatedState.approvers,
          updatedState.messageModal.userId,
        );
        updatedState.approversSelectionCount--;
      }
      if (
        updatedState.messageModal.userType === approvalsGroupText.users.title
      ) {
        removeSelectedUser(
          updatedState.users,
          updatedState.messageModal.userId,
        );
        updatedState.usersSelectionCount--;
      }
      updatedState.messageModal.showModal = false;
      break;
    case groupActions.CLOSE_MESSAGE_MODAL:
      updatedState.messageModal.showModal = false;
      break;
    case groupActions.UPDATE_GROUP_REQUEST:
      updatedState.submitGroupRequest = action.payload;
      break;
    case groupActions.ADD_USERS_REQUEST:
      if (updatedState.usersRequestParams === requestParams.ADMINS_ROLE) {
        updatedState.admins = addSelectedUsers(
          updatedState.admins,
          action.payload,
        );
        updatedState.adminsIsValid = true;
      }
      if (updatedState.usersRequestParams === requestParams.APPROVERS_ROLE) {
        updatedState.approvers = addSelectedUsers(
          updatedState.approvers,
          action.payload,
        );
        updatedState.approversIsValid = true;
      }
      if (updatedState.usersRequestParams === requestParams.USERS_ROLE) {
        updatedState.users = addSelectedUsers(
          updatedState.users,
          action.payload,
        );
        updatedState.usersIsValid = true;
      }
      updatedState.userModal.users = JSON.parse(JSON.stringify(action.payload));
      updatedState.submitUserRequest = false;
      break;
    case groupActions.UPDATE_USERS_REQUEST:
      updatedState.submitUserRequest = true;
      updatedState.usersRequestParams = action.payload.usersRequestParams;
      updatedState.userModal = action.payload.userModal;
      break;
    case groupActions.ERROR_USERS_REQUEST:
      if (updatedState.usersRequestParams === requestParams.ADMINS_ROLE) {
        updatedState.adminsIsValid = false;
        updatedState.adminsErrMsg = requestErrors.error;
      }
      if (updatedState.usersRequestParams === requestParams.APPROVERS_ROLE) {
        updatedState.approversIsValid = false;
      }
      if (updatedState.usersRequestParams === requestParams.USERS_ROLE) {
        updatedState.usersIsValid = false;
      }
      updatedState.userModal.showModal = false;
      updatedState.submitUserRequest = false;
      break;
    case groupActions.INITIAL_LOAD_REQUEST:
      updatedState.nameMaxLength = action.payload.nameMaxLength;
      updatedState.descriptionMaxLength = action.payload.descriptionMaxLength;
      updatedState.adminsCount = action.payload.adminsCount;
      updatedState.approversCount = action.payload.approversCount;
      updatedState.usersCount = action.payload.usersCount;
      updatedState.inititalLoadRequest = false;
      break;
    case groupActions.SET_UNLOAD_STATUS:
      updatedState.unloadListenerStatus = action.payload;
      break;
    default:
      // eslint-disable-next-line no-console
      console.error('Reducer action not found:', action.type);
  }

  return updatedState;
};
